import React from "react";
import {
  View,
  StyleSheet
} from "react-native";

import Style from "ae-style";

const styles = StyleSheet.create({
	dialogItem: {
		backgroundColor: Style.colors.white,
		padding: Style.layout.paddingSmall,
		borderWidth: 1,
		borderColor: "rgba(0,0,0,0.1)",
		width: 250,
		alignItems: "center",
		justifyContent: "center",
		zIndex: 2
	}
});

export default function DialogItem(props){
	const children = props.children;
	return (
		<View style={styles.dialogItem}>
			{children}
		</View>
	);
}
